import { useState } from "react";
import { CrossIcon, MailNotificationIcon } from "../Icons";
import CustomModal from "./CustomModal";
import MailAlertForm from "./MailAlertForm";

export default function MailNotificationBtn() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen((prev) => !prev);

  return (
    <div>
      <button
        onClick={toggleModal}
        className="p-2 text-gray-700 rounded-lg hover:text-custom-blue-medium hover:scale-90 hover:bg-gray-100"
        title="Manage mail notification"
      >
        <MailNotificationIcon />
      </button>

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="bg-white rounded-2xl shadow-2xl p-6 max-w-xl w-full relative"
      >
        <button
          onClick={toggleModal}
          className="absolute top-5 right-5 hover:scale-90 transition-transform"
        >
          <CrossIcon className="size-6 text-gray-600 hover:text-red-500" />
        </button>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-5 flex items-center gap-1">
            <MailNotificationIcon />
            Mail notification
          </h2>

          <MailAlertForm />
        </div>
      </CustomModal>
    </div>
  );
}
